import { Component, Input, OnInit } from '@angular/core';
import { ActionDtoModel } from '@bo-client/activation-management/shared/models/actionModel';
import { DataShareService } from '@bo-client/shared/services/data-share.service';

@Component({
  selector: 'app-gas-action-summary',
  templateUrl: './gas-action-summary.component.html',
  styleUrls: ['../../../../../../../shared/summaries/css-summary.component.scss']
})
export class GasActionSummaryComponent implements OnInit {
  @Input() actions: ActionDtoModel[] = [];

  constructor(private dataShareService: DataShareService) {}

  get showSealingOption() {
    return !this.dataShareService.tenantConfig.commissioning.gasConfig
      .hideGasMeterSealingOptionOnInstallationChange;
  }

  ngOnInit(): void {}
}
